import React, { FC } from 'react';
import FormItemLabel from 'antd/es/form/FormItemLabel';
import { Select } from 'antd';
import s from '../CustomSwitch/CustomSwitch.module.scss';
interface ICustomInput {
  options:
    | Array<{ label?: string; value: string }>
    | Array<{ name?: string; value: string | number }>;
  label: string;
  name: string;
  value: string | number;
  disabled?: boolean;
  fieldNames?: { label: string; value: string } | { name: string; value: string };
  handleChange: (name: string, value: string | boolean | number) => unknown;
  handleSaveXPath?: () => unknown;
}
export const CustomSelect: FC<ICustomInput> = ({
  label,
  fieldNames,
  name,
  value,
  disabled,
  handleChange,
  handleSaveXPath,
  options,
}) => {
  return (
    <div className={s.CustomSelect}>
      <FormItemLabel prefixCls={label} label={label} htmlFor={name} />
      <Select
        className={s.select}
        fieldNames={fieldNames}
        value={value}
        placeholder={label}
        onChange={(e) => handleChange(name, e)}
        onBlur={handleSaveXPath}
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
        // @ts-ignore
        options={options}
        disabled={disabled}
        // name={name}
      />
    </div>
  );
};
